
<template>
    <div v-if="questions && values">

      <div class="light-frame">
        <h3>General information (answer the questions in french)</h3>
        <form-question v-for="qid in questionIds1" :key="qid" class="light-frame"
          :question="questions[qid]"
          :values="values"
          :value="values[qid]"
          :error-message="errorMessages[questions[qid].a.type]"
          @answer-value="valueUpdated(qid, $event)"
        >
        </form-question>
      </div>

      <div class="light-frame">
        <h3>Address</h3>
        <form-question v-for="qid in questionIds2" :key="qid" class="light-frame"
          :question="questions[qid]"
          :values="values"
          :value="values[qid]"
          :error-message="errorMessages[questions[qid].a.type]"
          @answer-value="valueUpdated(qid, $event)"
        >
        </form-question>
      </div>


      <div class="light-frame">
        <h3>Contact Information</h3>
        <form-question v-for="qid in questionIds3" :key="qid" class="light-frame"
          :question="questions[qid]"
          :values="values"
          :value="values[qid]"
          :error-message="errorMessages[questions[qid].a.type]"
          @answer-value="valueUpdated(qid, $event)"
        >
        </form-question>
      </div>


    </div>
  </div>
</template>

<script>
import Question from './Question'

export default {
  components: {
    'form-question': Question
  },

  props: {
    questions: {
      type: Object,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errorMessages: {
      type: Object,
      required: true
    }
  },

  data: function () {
    return {
      questionIds1: [
        'id_user_civilite', 
        'id_user_prenom', 
        'id_user_nom', 
        'id_user_birthdate',
        'id_user_birthplace',
        'id_user_nationality'
      ],
      questionIds2: [
        'id_user_adress_street',
        'id_user_adress_zip',
        'id_user_adress_city',
        'id_user_adress_country'
      ],
      questionIds3: [
        'id_user_phnum',
        'id_user_mail',
        'id_user_mail_verification'
      ]


    }
  },

  created: function () {
  },

  methods: {
    hasError: function () {
      return !this.questionIds1.every(qid => this.questions[qid].checkCondition(this.values[qid], this.values)) ||
             !this.questionIds2.every(qid => this.questions[qid].checkCondition(this.values[qid], this.values)) ||
             !this.questionIds3.every(qid => this.questions[qid].checkCondition(this.values[qid], this.values))
    },

    valueUpdated: function (qid, v) {
      this.values[qid] = v
    }

  }
}
</script>


// WEBPACK FOOTER //
// UserForm.vue?30e138be